import { useRef, useEffect } from 'react';
import {  Grid, Icon, Typography } from "@mui/material"
import { grey } from "@mui/material/colors"
import Box from '@mui/material/Box';
import MobileSteps from '../MobileSteps';
import InputForm from "../../forms/InputForm"
import ContainedButton from "../../actions/ContainedButton"
import CeluHeader from './CeluHeader';

const EmailView = ({
    emailForm, 
    onChange,
    onRequestVerificationCode,
    loading,
    error, 
    onCloseError,
    stepper,
    onReturn
}) => {

    const emailRef = useRef()

    useEffect(() => {
        if(emailRef.current) emailRef.current.focus()
    }, [])

    const valid = emailForm.isValid

    return(
        <Box>
            <CeluHeader
                title='Ingresa tu email'
                enable_return onReturn={onReturn} 
            />
            <Box sx={{mt:3}}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <InputForm  ref={emailRef}  data={emailForm}  onChange={onChange}
                        inputProps={{autocomplete:'new-password', form: {autocomplete: 'off'}}}/>
                    </Grid> 
                </Grid>
            </Box>
            <Typography sx={{mt:2}}>
                Enviaremos un mensaje con un código de verificación a tu correo electrónico.
            </Typography>
            <Box sx={{
                minHeight:'36vh',
                width:'100%',
                position:'relative',
                height:{
                    sm:'38vh'
                }
            }}/>
            <MobileSteps 
                position={stepper?.position ?? 0}
                steps={stepper?.steps ?? 1}
            />
            <ContainedButton 
                fullWidth
                disabled={!valid} 
                onClick={onRequestVerificationCode}
                loading={loading}
            >Continuar</ContainedButton>
        </Box>
    )
}

export default EmailView